

















































import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ToolsService } from '@/services/ToolsService';

export default Vue.extend({
  name: 'ClearCacheSettings',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async clearV3ConnectorCache(this: any) {
      try {
        this.isLoading = true;
        await ToolsService.deleteV3ConnectorCacheSettings();
        SnotifyConfiguration.showSuccess('Server cache has been cleared successfully.');
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    }
  },
  components: {
    LoadingSpinner
  }
});
